define('ThemesHelper',[], function () {
  var ThemesHelper = {
    COOKIE_NAME: "md_theme",
    COOKIE_EXPIRATION_DAYS: 365,
    THEME_URI_SUFFIX: "/globals/src/",
    THEME_SUFFIX: "/signup/src/",
    AVAILABLE_THEMES: ["classicTheme", "newTheme", "v2", "v3"],
    DEFAULT_THEME: "v3",
    THEME_LOADING_FLAG: "theme-loading",

    addLoadingThemeFlag: function () {
      $("body").addClass(this.THEME_LOADING_FLAG);

      return this;
    },

    getScaleClass: function () {
      var scale = window.devicePixelRatio * 100;

      return "scale_" + scale;
    },

    removeLoadingThemeFlag: function () {
      $("body")
        .removeClass(ThemesHelper.THEME_LOADING_FLAG)
        .css("visibility", "visible")
        .addClass(ThemesHelper.getCurrentTheme())
        .addClass(ThemesHelper.getScaleClass());

      return this;
    },

    addThemeStylesheet: function () {
      var globalStylesheetURL = this.getGlobalThemeStylesheetURL(),
        customStylesheetURL = this.getCustomThemeStylesheetURL();

      this.addLoadingThemeFlag().loadCssFiles(
        [globalStylesheetURL, customStylesheetURL],
        this.removeLoadingThemeFlag
      );
    },

    loadCssFiles: function (urls, successCallback) {
      $.map(urls, function (url) {
        $.get(url, function (css) {
          $("<style>" + css + "</style>").appendTo("head");
        });
        setTimeout(function () {
          if (typeof successCallback === "function") successCallback();
        }, 1000);
      });
    },

    getGlobalThemeStylesheetURL: function () {
      return this.getCurrentThemeGlobalURL() + "styles/styles.css";
    },

    getCustomThemeStylesheetURL: function () {
      return this.getCurrentThemeURL() + "styles/styles.css";
    },

    getCurrentTheme: function () {
      if (typeof THEME === "undefined") {
        return this.DEFAULT_THEME;
      }

      return THEME.CURRENT_THEME;
    },

    setNewTheme: function (theme) {
      THEME.CURRENT_THEME = theme;
    },

    getCurrentThemeGlobalURL: function () {
      if (!THEME) {
        return "";
      }

      return THEME.ASSETS_URL + THEME.CURRENT_THEME + this.THEME_URI_SUFFIX;
    },

    getCurrentThemeURL: function () {
      if (!THEME) {
        return "";
      }

      return THEME.ASSETS_URL + THEME.CURRENT_THEME + this.THEME_SUFFIX;
    },

    getCookie: function (cname) {
      var name = cname + "=",
        decodedCookie = decodeURIComponent(document.cookie),
        ca = decodedCookie.split(";");

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length) !== "null"
            ? c.substring(name.length, c.length)
            : null;
        }
      }

      return null;
    },

    checkThemeGlobalVar: function (config) {
      if (window.THEME === undefined) {
        window.THEME = {
          ASSETS_URL: config.themeAssetsUrl || "",
          THEME_URL: "",
          CURRENT_THEME: "",
          COOKIE_DOMAIN: config.i18nCookieDomain,
        };
      }
    },

    buildThemeCookieExpirationDate: function () {
      var d = new Date();
      d.setTime(
        d.getTime() + this.COOKIE_EXPIRATION_DAYS * 24 * 60 * 60 * 1000
      );

      return "expires=" + d.toUTCString();
    },

    setCookieTheme: function (theme) {
      document.cookie =
        this.COOKIE_NAME +
        "=" +
        theme +
        ";" +
        this.buildThemeCookieExpirationDate() +
        "; path=/;Domain=" +
        THEME.COOKIE_DOMAIN +
        "; samesite=strict; Secure;";
    },

    setConfig: function (config) {
      this.checkThemeGlobalVar(config);
    },

    addThemeClass: function (userTheme) {
      $("body")
        .removeClass(this.AVAILABLE_THEMES.join(" "))
        .addClass(userTheme);
    },

    changeUserTheme: function (theme) {
      this.setCookieTheme(theme);
      this.initUserTheme(theme);
    },

    initUserTheme: function (theme) {
      var cookieTheme = this.getCookie(this.COOKIE_NAME),
        userTheme = this.DEFAULT_THEME;

      this.addThemeClass(userTheme);
      this.setNewTheme(userTheme);
      this.addThemeStylesheet();

      if (!cookieTheme) {
        this.setCookieTheme(userTheme);
      }
    },

    isTestEnvironment: function () {
      return window.location.hostname.indexOf("test") !== -1;
    },
  };

  return ThemesHelper;
});

